import React from 'react';
import { motion } from 'framer-motion';
export function ReframeSection() {
  return <section className="py-24 bg-background text-center px-4" data-id="element-166">
      <div className="max-w-4xl mx-auto" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} data-id="element-168">
          <p className="text-accent-yellow font-bold tracking-widest uppercase text-sm mb-4" data-id="element-169">
            The Truth Nobody Tells You
          </p>
          <h2 className="font-heading text-5xl md:text-7xl text-primary mb-8" data-id="element-170">
            IT'S NOT YOUR ENGLISH.
            <br data-id="element-171" />
            <span className="text-accent-orange" data-id="element-172">IT'S YOUR STRATEGY.</span>
          </h2>
          <div className="space-y-6 text-lg md:text-xl text-muted max-w-2xl mx-auto" data-id="element-173">
            <p data-id="element-174">
              Most English courses prepare you for a test. But life isn't a
              test.{' '}
              <span className="text-primary font-medium" data-id="element-175">
                Life is fast-paced, sarcastic, loud, and messy.
              </span>
            </p>
            <p data-id="element-176">
              When you're at a bar in Sydney or a networking event in New York,
              nobody cares if you use the "Present Perfect" correctly.{' '}
              <span className="text-accent-yellow font-bold" data-id="element-177">
                They care if you're relatable.
              </span>
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="my-12 bg-accent-yellow/10 border border-accent-yellow/30 rounded-2xl p-8 max-w-2xl mx-auto" style={{
        backgroundColor: 'rgba(0,214,143,0.08)',
        borderColor: 'rgba(0,214,143,0.25)'
      }} data-id="element-178">
          <p className="font-heading text-3xl md:text-4xl text-accent-yellow" data-id="element-179">
            "YOUR ACCENT ISN'T THE PROBLEM.
            <br data-id="element-180" />
            YOUR SCRIPTS ARE."
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-181">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6
        }} className="p-8 rounded-2xl bg-surface/50 border border-border opacity-70" data-id="element-182">
            <h3 className="font-heading text-2xl text-muted mb-4" data-id="element-183">
              THE OLD WAY
            </h3>
            <ul className="space-y-3 text-left text-muted" data-id="element-184">
              <li data-id="element-185">❌ Memorizing grammar rules</li>
              <li data-id="element-186">❌ Translating in your head</li>
              <li data-id="element-187">❌ Panicking when you don't understand</li>
              <li data-id="element-188">❌ Staying quiet to avoid mistakes</li>
            </ul>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="p-8 rounded-2xl bg-surface border border-accent-yellow/30 shadow-[0_0_30px_-10px_rgba(245,200,66,0.15)] relative overflow-hidden" data-id="element-189">
            <div className="absolute top-0 right-0 bg-accent-yellow text-background text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-190">
              THE SURVIVAL WAY
            </div>
            <h3 className="font-heading text-2xl text-accent-yellow mb-4" data-id="element-191">
              THE SURVIVAL WAY
            </h3>
            <ul className="space-y-3 text-left text-primary" data-id="element-192">
              <li data-id="element-193">✅ Using "Scripts" to buy time</li>
              <li data-id="element-194">✅ Focusing on connection, not perfection</li>
              <li data-id="element-195">✅ Handling "Wait, what?" with confidence</li>
              <li data-id="element-196">✅ Owning the room (even with mistakes)</li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}